import store from '@/store'

const beforeEnter = async (to, _from, next) => {
  store.commit('resetAlerts')
  next()
}

export default { beforeEnter }
